/**
 * Marks a portion of text intended to represent a word
 */
export class Word extends HTMLElement {

  _transcription : string;

  /**
   * Initializes a new instance
   */
  constructor() {
    super();
    this._transcription = "";
  }

  static observedAttributes = ["transcription"];

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore TS6133: 'oldValue' is declared but its value is never read.
  attributeChangedCallback(name : string, oldValue : string, newValue : string) {
    this._transcription = newValue;
    this._updateRendering();
  }

  connectedCallback() {
    this._updateRendering();
  }

  /**
   * Gets the phonetic transcription of the word represented by the portion of text
   */
  get transcription() {
    return this._transcription;
  }

  /**
   * Sets the phonetic transcription of the word represented by the portion of text
   */
  set transcription(v : undefined | null | string) {
    this.setAttribute("transcription", v ?? "");
  }

  _updateRendering() {
    // ...
  }
}
